import create from 'zustand';
import { IPackage } from '@root/types/package';
import { ILoading } from '@root/types/common';

export interface IState {
  packages: IPackage[];
  updateTime: number;
  /**
   * packageId 套餐升降级的数据会根据 packageId 变化
   */
  packageId: string;
  selectedPackage: IPackage | null;
  loading: ILoading;
  setLoading: (v: ILoading) => void;
  setPackages: (v: IPackage[], packageId: string) => void;
  setSelectedPackage: (v: IPackage) => void;
  resetInitData: () => void;
  resetSelectedData: () => void;
}

const usePackages = create<IState>((set) => ({
  packages: [],
  updateTime: 0,
  loading: -1,
  packageId: '',
  selectedPackage: null,
  setLoading: (loading) => {
    return set(() => {
      return {
        loading,
      };
    });
  },
  setPackages: (packages: IPackage[], packageId: string) => {
    return set(() => {
      return {
        updateTime: new Date().getTime(),
        packages,
        packageId: packageId || '',
      };
    });
  },
  setSelectedPackage: (selectedPackage: IPackage) => {
    return set(() => {
      return {
        selectedPackage,
      };
    });
  },
  resetInitData: () => {
    return set(() => {
      return {
        packages: [],
        selectedPackage: null,
        updateTime: 0,
        packageId: '',
        loading: -1,
      };
    });
  },
  resetSelectedData: () => {
    return set(() => {
      return {
        selectedPackage: null,
      };
    });
  },
}));

export default usePackages;
